<form class="row g-3" [formGroup]="securityForm" (ngSubmit)="createProfile()">
  <div>
    <div class="row pb-2">
      <div class="col-sm-6 mb-4">
        <div class="mb-3 position-relative">
          <label for="firstName" class="form-label fs-base">First Name</label>
          <input
            type="text"
            id="firstName"
            class="form-control form-control-lg"
            formControlName="firstName"
            [ngClass]="{ 'is-invalid': formsubmit && form.firstName.errors }" />
          @if (formsubmit && form.firstName.errors) {
            <div class="invalid-tooltip">
              @if (form.firstName.errors['required']) {
                <span>First name is required.</span>
              }
              <!-- <span *ngIf="form.firstName.errors['pattern']">This value should be a valid email.</span> -->
            </div>
          }
        </div>
      </div>
      <div class="col-sm-6 mb-4">
        <div class="mb-3 position-relative">
          <label for="lastName" class="form-label fs-base">Last Name</label>
          <input
            type="text"
            id="lastName"
            class="form-control form-control-lg"
            formControlName="lastName"
            [ngClass]="{ 'is-invalid': formsubmit && form.lastName.errors }" />
          @if (formsubmit && form.lastName.errors) {
            <div class="invalid-tooltip">
              @if (form.lastName.errors['required']) {
                <span>Last name is required.</span>
              }
              <!-- <span *ngIf="form.firstName.errors['pattern']">This value should be a valid email.</span> -->
            </div>
          }
        </div>
      </div>
      <!-- No email field (#1760): the visitor is already signed in — the backend
           resolves the identity email from the JWT and rejects a client-supplied one. -->
      <div class="col-sm-6 mb-4">
        <div class="mb-3 position-relative">
          <label for="phoneNumber" class="form-label fs-base">Phone Number</label>
          <input
            type="tel"
            id="phoneNumber"
            class="form-control form-control-lg"
            formControlName="phoneNumber"
            [ngClass]="{ 'is-invalid': formsubmit && form.phoneNumber.errors }" />
          @if (formsubmit && form.phoneNumber.errors) {
            <div class="invalid-tooltip">
              @if (form.phoneNumber.errors['required']) {
                <span>Phone number is required.</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="col-sm-6 mb-4">
        <div class="mb-3 position-relative">
          <label for="genderDropdown" class="form-label fs-base">Gender</label>
          <select
            id="genderDropdown"
            class="form-control form-select form-select-lg"
            name="gender"
            formControlName="gender"
            [ngClass]="{ 'is-invalid': formsubmit && form.gender.errors }">
            <option value="">Please Select</option>
            @for (gender of genderList; track gender.id) {
              <option [value]="gender.value">
                {{ gender.name }}
              </option>
            }
          </select>
          @if (formsubmit && form.gender.errors) {
            <div class="invalid-tooltip">
              @if (form.gender.errors['required']) {
                <span>Gender is required.</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="col-sm-6 mb-4">
        <div class="mb-3 position-relative">
          <label for="birthDate" class="form-label fs-base">Date of Birth</label>
          <input
            type="date"
            id="birthDate"
            class="form-control form-control-lg"
            formControlName="birthDate"
            [ngClass]="{ 'is-invalid': formsubmit && form.birthDate.errors }" />
          @if (formsubmit && form.birthDate.errors) {
            <div class="invalid-tooltip">
              @if (form.birthDate.errors['required']) {
                <span>Date of birth is required.</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="col-sm-6 mb-4">
        <div class="mb-3 position-relative">
          <label for="ethnicityDropdown" class="form-label fs-base">Ethnicity</label>

          <select
            id="ethnicityDropdown"
            class="form-control form-select form-select-lg"
            name="ethnicity"
            formControlName="ethnicity"
            [ngClass]="{ 'is-invalid': formsubmit && form.ethnicity.errors }">
            <option value="">Please Select</option>
            @for (ethnic of ethnicityList; track ethnic.id) {
              <option [value]="ethnic.name">
                {{ ethnic.name }}
              </option>
            }
          </select>
          @if (formsubmit && form.ethnicity.errors) {
            <div class="invalid-tooltip">
              @if (form.ethnicity.errors['required']) {
                <span>Ethnicity is required.</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="col-sm-6 mb-4">
        <div class="mb-3 position-relative">
          <label for="raceDropdown" class="form-label fs-base">Race</label>
          <select
            id="raceDropdown"
            class="form-control form-select form-select-lg"
            name="race"
            formControlName="race"
            [ngClass]="{ 'is-invalid': formsubmit && form.race.errors }">
            <option value="">Please Select</option>
            @for (race of raceList; track race.id) {
              <option [value]="race.name">
                {{ race.name }}
              </option>
            }
          </select>
          @if (formsubmit && form.race.errors) {
            <div class="invalid-tooltip">
              @if (form.race.errors['required']) {
                <span>Race is required.</span>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <!-- #2027: no reset "Cancel" here — the old `btn-secondary bg-white border-0`
         control was white-on-white in the light theme (same anti-pattern #1253
         removed from account-form), and a form-reset mid-onboarding only wipes
         what the user just typed. Single primary CTA, per the sibling form. -->
    <div class="d-flex mb-3">
      <button type="submit" class="btn btn-primary">Complete</button>
    </div>
  </div>
</form>
